import { render, staticRenderFns } from "./renja_tindak_lanjut.vue?vue&type=template&id=e6ef1e30&"
import script from "./renja_tindak_lanjut.vue?vue&type=script&lang=js&"
export * from "./renja_tindak_lanjut.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports